"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var ModalTitle = function ModalTitle(_ref) {
  var content = _ref.content,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading4,
    content: content
  }, children);
};

exports.ModalTitle = ModalTitle;